import { useOidc, useOidcAccessToken } from '@axa-fr/react-oidc';

import { isDev } from '@shared/utils/environment';

const useIsAuthenticated = () => {
  const { accessToken } = useOidcAccessToken();
  const { isAuthenticated } = useOidc();

  return {
    isAuthenticated: (isAuthenticated && !!accessToken) || isDev(),
  };
};

export default useIsAuthenticated;
